import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'
import axios from 'axios'

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  
  /* console.log('error below')
  console.log(typeof err)
  console.log(err)
  console.log('VM')
  console.log(vm)
  console.log('Info unten')
  console.log(info) */

  const path = `https://api.fesch-bau.de/error`
  
  axios.post(path ,
    {
      reported_err: err,
      reported_vm: String(vm),
      reported_info: String(info)
    }
  ).then(() => {
    console.log('SUCCESS')
  })
  .catch(function(error){
    console.log('FAILURE')
    console.log(error)
  })
}

new Vue({
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')
